import { render, staticRenderFns } from "./ValuesGrid.vue?vue&type=template&id=0c57900d&scoped=true&"
import script from "./ValuesGrid.vue?vue&type=script&lang=ts&"
export * from "./ValuesGrid.vue?vue&type=script&lang=ts&"
import style0 from "./ValuesGrid.vue?vue&type=style&index=0&id=0c57900d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c57900d",
  null
  
)

export default component.exports